// removed by extract-text-webpack-plugin
module.exports = {"component":"_1NLrBCMfM8WdYlyVY9XHWK","header":"w3S960HMUUloZpDz0-vZU","form":"jN_5nB0bhtUzGN0tV6IXJ","group":"_1M83cKpGIo9H6Vv2jRvNnQ","groupStacked":"_1YbqpXJL46q1L3rhzIkX-z","dateFilter":"_2fraB7CWI5kJJGqEDPC1gv","label":"_3ydaa-W6cLJcAaTftcUaYF","controlContainer":"_3TOrrhTng_QP_KTKtbIDSH","control":"hB9XQqb6tSrbTd0bjw8IW","textarea":"_1ypl3ADBpaQpQZumL97DUj","btn":"edRfkAm_RGG01C-QWFQhf","margins":"_2hPGRvwvdPySscIflpBcn6","textAreaContainer":"_30UZ-OVx9LQ6cGrrz8uyar","checkboxLabel":"_2QoPc7B8XjlRWM-bxL7xO3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Account/GrantUserAccess/GrantUserAccess.css
// module id = 1484
// module chunks = 0